import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M2 8h1.832C5.375 4.468 8.899 2 13 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.1 0-7.625-2.468-9.168-6H2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "4",
  height: "2",
  y: "11",
  fill: "#fff",
  rx: "1"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#CF0",
  "stroke-width": "2",
  d: "m15.194 13.692.884-.152-.884.152.298 1.739-1.561-.821a2 2 0 0 0-1.862 0l-1.562.82.299-1.739a2 2 0 0 0-.575-1.77L8.967 10.69l1.746-.254a2 2 0 0 0 1.506-1.094l-.897-.443.897.443L13 7.76l.78 1.582.898-.443-.897.443a2 2 0 0 0 1.506 1.094l1.746.254-1.264 1.231.698.716-.698-.716a2 2 0 0 0-.575 1.77Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }